import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RowBody } from "../../../../components/RowValue/RowBody";
import {
  Measurements,
  selectMeasurementType,
  setMeasurementType,
} from "../../../../store/slices/settingsSlice";

function MeasurementTypeSelection() {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const measurementType = useSelector(selectMeasurementType);

  return (
    <RowBody
      titleValue={<p>{t("aashto.Imperial / Metric")}</p>}
      inputValue={
        <select
          value={measurementType}
          onChange={(e) => {
            dispatch(setMeasurementType(e.target.value));
          }}
          className="change-input"
          name="loadType"
          id="loadType"
        >
          <option value={Measurements.IMPERIAL}>{t("aashto.Imperial")}</option>
          <option value={Measurements.METRIC}>{t("aashto.Metric")}</option>
        </select>
      }
    />
  );
}

export default MeasurementTypeSelection;
